import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errorText } from "../lib/api";
import { formatPrice } from "../lib/site";

const STATUSES = ["paid", "ready", "dispatched", "delivered", "cancelled"];
const fmtDate = (s) => (s ? new Date(s).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "");

export default function OrdersTab({ onChange }) {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/orders").then((r) => setRows(Array.isArray(r.data) ? r.data : [])).catch((e) => toast.error(errorText(e)));
  }, []);

  const setStatus = async (id, status) => {
    await api.patch(`/orders/${id}`, { status });
    setRows((rs) => rs.map((r) => (r.id === id ? { ...r, status } : r)));
    onChange?.();
  };

  return (
    <div className="overflow-x-auto rounded-2xl border border-navy/10 bg-white">
      <table data-testid="admin-orders-table" className="w-full min-w-[900px] text-sm">
        <thead className="bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-500">
          <tr><th className="p-3">Date</th><th className="p-3">Product</th><th className="p-3">Qty</th><th className="p-3">Amount</th><th className="p-3">Customer</th><th className="p-3">Fulfilment</th><th className="p-3">Payment ID</th><th className="p-3">Status</th></tr>
        </thead>
        <tbody>
          {rows.map((o) => (
            <tr key={o.id} className="border-t border-navy/5 align-top">
              <td className="p-3 whitespace-nowrap text-slate-600">{fmtDate(o.created_at)}</td>
              <td className="p-3 font-semibold text-navy">{o.product_name}</td>
              <td className="p-3">{o.quantity}</td>
              <td className="p-3 font-semibold">{formatPrice(o.amount)}</td>
              <td className="p-3">{o.name}<div className="text-xs text-slate-500">{o.phone}{o.email ? ` · ${o.email}` : ""}</div></td>
              <td className="p-3 capitalize">{o.fulfilment}{o.fulfilment === "delivery" && <div className="text-xs normal-case text-slate-500">{o.address}, {o.city} {o.pincode}</div>}</td>
              <td className="p-3 font-mono text-xs">{o.razorpay_payment_id || "—"}</td>
              <td className="p-3">
                {o.status === "failed" ? <span className="text-red-600 font-semibold">failed</span> : (
                  <select data-testid={`admin-order-status-${o.id}`} value={o.status} onChange={(e) => setStatus(o.id, e.target.value)} className="rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold">
                    {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                )}
              </td>
            </tr>
          ))}
          {rows.length === 0 && <tr><td colSpan={8} className="p-10 text-center text-slate-500">No online orders yet.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
